import '@/assets/style/main.css';
import { AntButton } from '@/common/ant-components/AntButton';
import RadioButtonGroup from '@/common/ant-components/RadioGroupReport';
import {
  getAdFromBS,
  getBsFromAD,
  getTodayDate,
} from '@/common/custom-date-selector/helpers';
import { NewNepaliDatePicker } from '@/common/customNepaliDatePicker';
import { useNavigationHistory } from '@/common/navigation-history';
import { returnLinks } from '@/common/navigation-history/data';
import LedgerForm from '@/components/forms/master/account/ledger/LedgerForm';
import { useTransactionContext } from '@/context/TransactionContext';
import { optionSearchFunction } from '@/utils/common';
import GlobalFormModal from '@/utils/modal/GlobalFormModal';
import CustomSelect from '@/utils/search/Search';
import { CloseOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons';
import { Col, DatePicker, Form, Input, Row, Table } from 'antd';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConfirmDelete } from '../transaction/reuse/modals-delete/confirm-delete';
import { dateType as backendDateType } from '@/common/custom-date-selector-list/helpers';
import useAppData from '@/hooks/useAppData';

export const VoucherHeader = ({ name, showFeilds, dateFieldName }) => {
  const { app } = useAppData();

  const [dateType, setDateType] = useState(
    app?.dateType === 'bs' ? 'bs' : 'ad',
  );

  const handleRadio = (e) => {
    setDateType(e?.target?.value);
  };

  const formD = Form.useFormInstance();
  const isIssueDate = dateFieldName === 'issueDate';
  const isReceiptDate = dateFieldName === 'receiptDate';

  return (
    <>
      <h2 className="text-center !tw-mb-0">{name}</h2>
      {showFeilds ? (
        <Row gutter={[16, 16]} justify="space-between">
          <Col xs={24} md={4}>
            <Form.Item label="Bill Number" name="billNumber">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={2} style={{ marginLeft: 'auto' }}>
            <RadioButtonGroup
              name="date_type"
              initialValue={dateType}
              onChange={handleRadio}
            />
          </Col>
          <Col xs={24} md={dateType === 'ad' ? 4 : 0}>
            {isIssueDate && (
              <Form.Item label="Date" name={'issueDate'} initialValue={dayjs()}>
                <DatePicker
                  format="YYYY-MM-DD"
                  style={{ width: '100%' }}
                  className="date-picker"
                  disabledDate={(current) =>
                    current.isBefore(app?.financialStartYear, 'day') ||
                    current.isAfter(app?.financialEndYear)
                  }
                  onChange={(date) => {
                    if (date) {
                      formD.setFieldsValue({
                        date_bs: getBsFromAD(date),
                      });
                    }
                  }}
                />
              </Form.Item>
            )}
            {isReceiptDate && (
              <Form.Item
                label="Date"
                name={'receiptDate'}
                initialValue={dayjs()}
              >
                <DatePicker
                  format="YYYY-MM-DD"
                  style={{ width: '100%' }}
                  className="date-picker"
                  disabledDate={(current) =>
                    current.isBefore(app?.financialStartYear, 'day') ||
                    current.isAfter(app?.financialEndYear)
                  }
                  onChange={(date) => {
                    if (date) {
                      formD.setFieldsValue({
                        date_bs: getBsFromAD(date),
                      });
                    }
                  }}
                />
              </Form.Item>
            )}
          </Col>

          <Col xs={24} md={12} lg={dateType === 'ad' ? 0 : 4}>
            <NewNepaliDatePicker
              formProps={{
                name: 'date_bs',
                label: 'Date',
                initialValue: getTodayDate(),
                hidden: dateType === 'ad',
              }}
              disabledBefore={getBsFromAD(app?.financialStartYear)}
              disabledAfter={getBsFromAD(app?.financialEndYear)}
              onChange={(e) => {
                if (!e) return;
                const adDate = getAdFromBS(e);
                formD.setFieldsValue({
                  issueDate: adDate,
                  receiptDate: adDate,
                });
              }}
            />
          </Col>
        </Row>
      ) : (
        <Row gutter={[16, 16]}>
          <Col xs={24} md={4}>
            <Form.Item label="Voucher Number" name="voucherNumber">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} lg={2} style={{ marginLeft: 'auto' }}>
            <RadioButtonGroup
              name="date_type"
              initialValue={dateType}
              onChange={handleRadio}
            />
          </Col>
          <Col xs={24} md={dateType === 'ad' ? 4 : 0}>
            <Form.Item label="Date" name="voucherDate" initialValue={dayjs()}>
              <DatePicker
                format="YYYY-MM-DD"
                style={{ width: '100%' }}
                className="date-picker"
                disabledDate={(current) =>
                  current.isBefore(app?.financialStartYear, 'day') ||
                  current.isAfter(app?.financialEndYear)
                }
                onChange={(date) => {
                  if (date) {
                    formD.setFieldsValue({
                      date_bs: getBsFromAD(date),
                    });
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} lg={dateType === 'ad' ? 0 : 4}>
            <NewNepaliDatePicker
              formProps={{
                name: 'date_bs',
                label: 'Date',
                initialValue: getTodayDate(),
                hidden: dateType === 'ad',
              }}
              disabledBefore={getBsFromAD(app?.financialStartYear)}
              disabledAfter={getBsFromAD(app?.financialEndYear)}
              onChange={(e) => {
                if (!e) return;
                const adDate = getAdFromBS(e);
                formD.setFieldsValue({ voucherDate: adDate });
              }}
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export const VoucherParty = ({
  labelName,
  feildName,
  ledgers,
  refreshTable,
  fromMetalCash,
  disabled = false,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleAddClick = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };
  return (
    <>
      {fromMetalCash ? (
        <Form.Item
          name={labelName}
          label={feildName}
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
        >
          <CustomSelect
            placeholder="Select Ledger Name"
            showSearch
            filterOption={optionSearchFunction}
            options={
              ledgers?.length
                ? ledgers?.map((ledger) => {
                    return {
                      key: ledger.referenceId,
                      value: ledger.referenceId,
                      label: ledger.name,
                    };
                  })
                : []
            }
            onAddClick={handleAddClick}
          />
        </Form.Item>
      ) : (
        <Row gutter={[16, 16]} className="mb-1">
          <Col xs={24} md={6}>
            <Form.Item
              name={labelName}
              label={feildName}
              rules={[
                {
                  required: true,
                  message: 'Please select received from',
                },
              ]}
            >
              <CustomSelect
                placeholder="Select Ledger Name"
                showSearch
                filterOption={optionSearchFunction}
                options={
                  ledgers?.length
                    ? ledgers?.map((ledger) => {
                        return {
                          key: ledger.referenceId,
                          value: ledger.referenceId,
                          label: ledger.name,
                        };
                      })
                    : []
                }
                disabled={disabled}
                onAddClick={handleAddClick}
              />
            </Form.Item>
          </Col>
        </Row>
      )}

      <GlobalFormModal isVisible={isModalVisible} onClose={closeModal}>
        {fromMetalCash ? (
          <LedgerForm
            onClose={closeModal}
            refreshTable={refreshTable}
            showKarigarAccount={true}
          />
        ) : (
          <LedgerForm
            onClose={closeModal}
            refreshTable={refreshTable}
            showPersonalAccount={true}
          />
        )}
      </GlobalFormModal>
    </>
  );
};

export const VoucherTable = ({ columns, dataSource, summary }) => {
  return (
    <Table
      className="mb-1"
      bordered
      pagination={false}
      columns={columns}
      dataSource={dataSource?.map((item, index) => ({
        ...item,
        key: index, // or generate unique ID
      }))}
      scroll={{ x: true, y: 300 }}
      summary={() => summary}
    />
  );
};

export const VoucherFooterButton = ({
  id,
  isFromModal,
  onClose,
  path,
  barcodePrint,
  drawer,
  buttonRef = null,
  discountRef = null,
  loading,
  handleModalClose,
}) => {
  const navigate = useNavigate();

  const [yesNo, setYesNo] = useState(false);

  const history = useNavigationHistory();

  const location = useLocation();

  const state = location?.state || null;

  const { ledgerDetails, stockDetails } = useTransactionContext();

  const exclude = [
    '/codewindow',
    '/sales/return/code/window',
    '/purchase/return/code/window',
    '/transaction/sales/create/',
    '/transaction/sales/edit/',
    '/ledger-details/reports/',
    '/stock/detail/report/',
    '/stock/ledger/report/',
    '/sundry-creditors/reports/',
    '/sundry-debtors/reports/',
    '/sundry-ledger-details/reports/',
    '/debtors-ledger-details/reports/',
    '/cash-bank-ledger-details/reports/',
    '/ledger/cash-bank/reports/',
  ];

  const isExcluded = exclude?.some((path) =>
    location?.pathname?.startsWith(path),
  );

  const target = isExcluded
    ? null
    : Array.isArray(history)
      ? [...history]
          .reverse()
          .find(
            (path, index) =>
              index === 1 &&
              returnLinks?.some((prefix) => path.startsWith(prefix)),
          )
      : null;

  // const stateData = ledgerDetails || stockDetails || state;

  const stateData = ledgerDetails
    ? ledgerDetails
    : stockDetails?.code
      ? stockDetails
      : state;

  const editURls = [
    '/purchase/edit/',
    '/sales/edit/',
    '/sales/order/edit/',
    '/sales/return/edit/',
    '/purchase/return/edit/',
    '/issue/karigar/edit/',
    '/issue/refine/edit/',
    '/issue/party/edit/',
    '/receive/karigar/edit/',
    '/receive/refine/edit/',
    '/receive/party/edit/',
    '/payment/voucher/edit/',
    '/contra/voucher/edit/',
    '/journal/voucher/edit/',
    '/receipt/voucher/edit/',
    '/metal-cash-payment/edit/',
    '/metal-cash-receipt/edit/',
    '/opening/stock/edit/',
  ];

  const excludeDelete = [
    '/transaction/sales/edit/',
    '/transaction/sales/order/edit/',
    '/transaction/receive/refine/edit/',
    '/transaction/receive/karigar/edit/',
    '/transaction/receive/party/edit/',
  ];

  const isExcludedDelete = excludeDelete?.some((path) =>
    location?.pathname?.startsWith(path),
  );
  const isEdit =
    editURls.some((path) => location?.pathname?.includes(path)) &&
    !isExcludedDelete;
  const handleKeyDown = useCallback((e) => {
    if (e.code === 'KeyD' && e.altKey) {
      e.preventDefault();
      setYesNo(true);
    }
  }, []);

  useEffect(() => {
    window.removeEventListener('keydown', handleKeyDown);
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const yesRef = React.useRef(null);
  const noRef = React.useRef(null);

  return (
    <>
      <div className="tw-flex tw-justify-end tw-py-[4px]">
        <div
          style={{
            display: 'flex',
            float: 'right',
            gap: '10px',
          }}
        >
          {isFromModal ? (
            <>
              <AntButton
                onClick={() => onClose()}
                color="green"
                htmlType="submit"
                icon={<SaveOutlined />}
              >
                Save [F10]
              </AntButton>
              <AntButton
                onClick={() => onClose()}
                icon={<CloseOutlined />}
                color="red"
              >
                Cancel
              </AntButton>
            </>
          ) : (
            <>
              {isEdit && (
                <AntButton
                  icon={<DeleteOutlined />}
                  color="darkRed"
                  danger
                  onClick={() => {
                    setYesNo(true);
                    setTimeout(() => {
                      noRef?.current?.focus();
                    }, 100);
                  }}
                >
                  Delete
                </AntButton>
              )}
              <AntButton
                color="green"
                htmlType="submit"
                onClick={barcodePrint}
                loading={loading}
                ref={buttonRef}
                disabled={loading}
                icon={<SaveOutlined />}
                onKeyDown={(e) => {
                  if (e.code === 'ArrowRight') {
                    e.preventDefault();
                    e.target.nextSibling.focus();
                  }
                  if (e.altKey && e.code === 'ArrowUp') {
                    e.preventDefault();
                    discountRef?.current?.focus();
                  }
                }}
              >
                Save [F10]
              </AntButton>
              <AntButton
                color="red"
                onClick={() => {
                  handleModalClose && handleModalClose();
                  target
                    ? navigate(target, {
                        state: {
                          ...stateData,
                          from: state?.from === 'sundry' ? 'sundry' : null,
                        },
                      })
                    : navigate(path);
                }}
                onKeyDown={(e) => {
                  if (e.code === 'ArrowLeft') {
                    e.preventDefault();
                    e.target.previousSibling.focus();
                  }
                  if (e.altKey && e.code === 'ArrowUp') {
                    e.preventDefault();
                    discountRef?.current?.focus();
                  }
                }}
                icon={<CloseOutlined />}
              >
                Cancel
              </AntButton>
            </>
          )}
        </div>
        <ConfirmDelete
          yesNo={yesNo}
          noRef={noRef}
          yesRef={yesRef}
          setYesNo={setYesNo}
        />
      </div>
    </>
  );
};

export const VoucherFooterButtonAdmin = ({
  id,
  isFromModal,
  onClose,
  path,
  barcodePrint,
  drawer,
  buttonRef = null,
  discountRef = null,
  loading,
  handleModalClose,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="tw-flex tw-justify-end tw-py-[10px]">
        <div
          style={{
            display: 'flex',
            float: 'right',
            gap: '10px',
          }}
        >
          {isFromModal ? (
            <>
              <AntButton
                onClick={() => onClose()}
                color="green"
                htmlType="submit"
                icon={<SaveOutlined />}
              >
                Save [F10]
              </AntButton>
              <AntButton
                onClick={() => onClose()}
                icon={<CloseOutlined />}
                color="red"
              >
                Cancel
              </AntButton>
            </>
          ) : (
            <>
              <AntButton
                color="green"
                htmlType="submit"
                onClick={barcodePrint}
                loading={loading}
                ref={buttonRef}
                disabled={loading}
                icon={<SaveOutlined />}
              >
                Save [F10]
              </AntButton>
              <AntButton
                color="red"
                className="cancel-button"
                onClick={() => {
                  handleModalClose && handleModalClose();
                  navigate(-1);
                }}
                icon={<CloseOutlined />}
              >
                Cancel
              </AntButton>
            </>
          )}
        </div>
      </div>
    </>
  );
};
